import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./fitmentIcon.module.scss";

const FitmentIcon = () => (
  <img
    src={getRelativeImagePath("/images/public/engine.webp")}
    alt="engine"
    className={`m-r-10 ${styles.engine_icon}`}
    width={20}
    height={20}
  />

);

export default FitmentIcon;
